<template>
  <div>
    <f7-list-item
        :footer="video.subtitle"
        @click.prevent="$emit('opened')"
        :title="video.title" link="#"
          v-if="matchesQuery"
    ></f7-list-item>
    <video-sheet
        :show="show"
        :video="video"
        @closed="$emit('closed')">
    </video-sheet>
  </div>
</template>

<script>

  import VideoSheet from "./VideoSheet.vue";
  import utility from "../../js/utility";

  export default {
    components: {VideoSheet},

    props: ['video', 'query', 'show'],

    mixins: [],

    data: function () {
      return {
        //
      };
    },

    computed: {
      matchesQuery() {
        if(this.query.length <= 3) {
          return true;
        }
        return utility.string_contains_query(this.video.title, this.query)
      }
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      //
    },

    watch: {
      //
    }
  };
</script>
